<template>
<div class="chapter">
<div class="inner_page">
<p class="C1613"><span id="page_6">From </span>Our House to Your House</p>
<p class="C1600">It is 1959. It is the cusp of the coming revolution.</p>
<p class="C1600">We still like Ike. We are still afraid of Sputnik.</p>
<p class="C1600">We read <em>Life </em>magazine and <em>Sports Illustrated</em></p>
<p class="C1600">where the athletes grow up shooting hoops</p>
<p class="C1600">in the driveway, playing catch in the backyard.</p>
<p class="C1600">We sit on our sectional sofa. My mother loves</p>
<p class="C1600">Danish modern. Our pants have cuffs. Our hair</p>
<p class="C1600">is short. We are smiling and we mean it. I am</p>
<p class="C1600">a guard. My father is my coach. I am sitting</p>
<p class="C1600">next to him on the bench. I am ready to go in.</p>
<p class="C1600">My sister will cheer. My mother will make</p>
<p class="C1600">the pre-game meal from <em>The Joy of Cooking</em>.</p>
<p class="C1600">Buster is a good dog. We are all at an angle.</p>
<p class="C1600">We are a family at an angle. Our clothes are</p>
<p class="C1600">pressed. We look into the eye of the camera.</p>
<p class="C1600">“Look ’em in the eye,” my father teaches us.</p>
<p class="C1600">All we see ahead are wins, good grades,</p>
<p class="C1600">Christmas. We believe in being happy. We</p>
<p class="C1600">believe in mowing the lawn, a two-car garage,</p>
<p class="C1600">a freezer, and what the teacher says. There is</p>
<p class="C1600">nothing on the wall. We are facing away</p>
<p class="C1600">from the wall. The jungle is far from home.</p>
<p class="C1600">Hoses are for cleaning the car, watering</p>
<p class="C1600">the gardens. My sister walks to school. My</p>
<p class="C1600">father and I lean into the camera. My mother</p>
<p class="C1600">and sister sit up straight. Ike has kept us</p>
<p class="C1600">safe. In the spring, we will have a new car,</p>
<p class="C1600">a Plymouth Fury with whitewalls and a vinyl top.</p>
<p class="C1529"><span id="page_7"><img alt="" class="Image2" src="html/images/Image_20_0.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_From_Our.vue?e898148a